import React from "react";
import { Box, Button, Stack, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const ButtonColors = () => {
  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Buttons Colors
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          The Button Provides Eight colors variations: primary, secondary,
          error, warning, info, success, inherit and inheritWhite. All the
          colors are applied here in the default <strong>contained</strong>{" "}
          Button.
        </Typography>
      </Box>

      <Box sx={{ width: "80%", alignSelf: "center" }}>
        <PreviewAndEditor
          title={
            "primary, secondary, error, warning, info, success, inherit and inheritWhite Colored Button"
          }
          language={"js"}
          value={
            "            <Button>primary</Button>\n" +
            "            <Button color={'secondary'}>secondary</Button>\n" +
            "            <Button color={'error'}>error</Button>\n" +
            "            <Button color={'warning'}>warning</Button>\n" +
            "            <Button color={'info'}>info</Button>\n" +
            "            <Button color={'success'}>success</Button>\n" +
            "            <Button color={'inherit'}>inherit</Button>\n" +
            "            <Button color={'inheritWhite'}>inherit white</Button>"
          }
        >
          <Button>primary</Button>
          <Button color={"secondary"}>secondary</Button>
          <Button color={"error"}>error</Button>
          <Button color={"warning"}>warning</Button>
          <Button color={"info"}>info</Button>
          <Button color={"success"}>success</Button>
          <Button color={"inherit"}>inherit</Button>
          <Button color={"inheritWhite"}>inherit white</Button>
        </PreviewAndEditor>
      </Box>
    </Stack>
  );
};

export default ButtonColors;
